import { AxiosError } from "axios";
import { State } from "../models/state";
import { backend } from "../utils/axios";

const ROUTE = "/states";

interface StateServicesEndpoints {
  getStates: (query?: string) => Promise<State[]>;
  getActiveStates: () => Promise<State[]>;
  getState: (stateId: number) => Promise<State | undefined>;
  getActiveStatesByElectionType: (electionTypeId: number) => Promise<State[]>;
}

export const StateService: StateServicesEndpoints = {
  getStates: async (query?: string) => {
    const params = new URLSearchParams();
    if (query) params.append("query", query);

    const { data } = await backend.get<State[]>(ROUTE, { params });

    return data;
  },
  getActiveStates: async (): Promise<State[]> => {
    const { data } = await backend.get<State[]>("/states/active");

    return data;
  },
  getState: async (stateId: number) => {
    try {
      const { data } = await backend.get<State>(`${ROUTE}/${stateId}`);

      return data;
    } catch (e) {
      if ((e as AxiosError).response?.status === 404) return undefined;
      else return ((e as AxiosError).response?.data as any)?.statusText;
    }
  },
  getActiveStatesByElectionType: async (electionTypeId: number): Promise<State[]> => {
    const { data } = await backend.get<State[]>(`/states/active/${electionTypeId}`);

    return data;
  },
};
